import { all } from "redux-saga/effects";
import watchSignInSaga from "./signIn";
import watchGetUsersSaga from "./getUsers";
import watchGetUserSaga from "./getUser";
import watchGetCategoriesSaga from "./getCategories";
import watchGetSubcategoriesSaga from "./getSubcategories";
import watchGetQuestionsSaga from "./getQuestions";
import watchGetGameManagementSaga from "./getGameManagement";
import watchGetShowSaga from "./getShows";
import watchGetEntitySaga from "./getEntity";

export default function* rootSaga () {
    yield all([
        watchSignInSaga(),
        watchGetUsersSaga(),
        watchGetUserSaga(),
        watchGetCategoriesSaga(),
        watchGetSubcategoriesSaga(),
        watchGetQuestionsSaga(),
        watchGetGameManagementSaga(),
        watchGetShowSaga(),
        watchGetEntitySaga(),
    ])
};
